<template>
  <v-dialog
    ref="dialog"
    v-model="isOpen"
    :return-value.sync="date"
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateLabel"
        :label="labelFormatted"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      type="month"
      scrollable
      :min="minFormatted"
      :max="maxFormatted"
    >
      <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
      <v-btn text color="primary" @click="isOpen = false"> Cancel </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'MonthPicker',
  props: ['value', 'label', 'min', 'max'],

  data() {
    return {
      isOpen: false,
    }
  },

  computed: {
    date: {
      get() {
        return this.formatDate(this.value)
      },
      set(date) {
        this.$emit('input', new Date(date))
      },
    },

    dateLabel() {
      return `${this.value.getFullYear()}-${String(
        this.value.getMonth() + 1
      ).padStart(2, '0')}`
    },

    minFormatted() {
      if (!this.min) {
        return undefined
      }

      return this.formatDate(this.min)
    },

    maxFormatted() {
      if (!this.max) {
        return undefined
      }

      return this.formatDate(this.max)
    },

    labelFormatted() {
      if (!this.label) {
        return 'Date'
      }

      return this.label
    },
  },

  methods: {
    formatDate(date) {
      if (!date) {
        return ''
      }

      let formatted = ''

      formatted += date.getUTCFullYear()
      formatted += '-'
      formatted += String(date.getUTCMonth() + 1).padStart(2, '0')
      formatted += '-'
      formatted += String(date.getUTCDate()).padStart(2, '0')

      return formatted
    },
  },
}
</script>

<style scoped></style>
